import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleJdModelState,
  updateActiveSubSubTab,
  updateActiveSubTab,
  updateActiveTab,
  updateNavigationTab,
} from '../store/slices/candidateManagementSlice';
import {
  getJobDescriptionThunk,
  getJobPositionsforDropdown,
  getJobPositionsThunk,
  getSourcedCandidatesThunk,
} from '../store/thunks/InterviewThunk';
import DropDownWithSearch from '../components/shared/DropDownWIthSearch';
import { useTheme } from '../hooks/useTheme';
import FilterComponent from './shared_components/FilterComponent';
import FilterDropDown from './shared_components/FilterDropDown';
import {
  ArrowLeft,
  BriefcaseBusiness,
  ChevronDown,
  EllipsisVertical,
  Minus,
  MoveLeft,
  X,
} from 'lucide-react';
import ColumnDropDown from './shared_components/ColumnDropDown';
import {
  removeActiveFilter,
  triggerApply,
  updateCurrentJobRole,
} from '../store/slices/filterOptionsSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { clearInterviewManagementSlice } from '../store/slices/InterviewManagementSlice';
import HelpVideoModal from './shared_components/HelpVideoModal';
import { HELP_VIDEOS } from '../config/helpVideos';
import { useSourcingConfig } from '../contexts/SourcingConfigContext';

function CandidateManagementHeader() {
  const { sourcingEnabled, loading: sourcingConfigLoading } =
    useSourcingConfig();
  const [showDropDown, setShowDropDown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isHelpVideoOpen, setIsHelpVideoOpen] = useState(false);
  const currentActiveTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  const currentActiveSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const allJobs = useSelector(
    (state) => state.interviewManagementSlice.jobroles,
  );
  const jobRolesForDropDown = useSelector(
    (state) => state.interviewManagementSlice.jobRolesForDropDown,
  );
  const selectedJobDescription = useSelector(
    (state) => state.candidateManagementSlice.selectedJobDescription,
  );
  const [selectedJob, setSelectedJob] = useState(null);
  const showFilterDropdown = useSelector(
    (state) => state.filterSlice.showFilterDropdown,
  );
  const selectedJobRole = useSelector(
    (state) => state.filterSlice.currentJobRole,
  );
  const location = useLocation();
  const navigate = useNavigate();
  const portal = location.pathname.startsWith('/hr') ? 'hr' : 'org-admin';
  const { theme } = useTheme();
  const navigationTab = useSelector(
    (state) => state.candidateManagementSlice.navigationTab,
  );
  const dropdownRef = useRef(null);
  const showBackBtn = location.pathname.includes('/jobs/');
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropDown(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(toggleJdModelState());
  };

  const handleSelectJob = (job) => {
    setSelectedJob(job.label);
    console.log({ job });
    dispatch(getJobDescriptionThunk(job.value));
    dispatch(updateCurrentJobRole(job.label));
  };

  console.log({ selectedJobDescription });
  const handleToggleTab = (tabName) => {
    dispatch(updateActiveTab(tabName));
  };

  const handleToggleSubTab = (tabName) => {
    // If the user clicks the tab that is already active, do nothing.
    // Clearing + not re-fetching would leave the table empty.
    if (tabName === currentActiveSubTab) return;

    if (tabName === 'ALL') {
      dispatch(updateActiveSubSubTab('All'));
    }
    dispatch(clearInterviewManagementSlice({ clearJobRoles: false }));
    dispatch(updateActiveSubTab(tabName));
    
  };

  const handleUploadResumeClick = () => {
    const route =
      portal === 'org-admin' ? '/org-admin/checkresume' : '/hr/checkresume';
    dispatch(updateNavigationTab('ALL'));
    console.log({ selectedJobDescription });
    if (!selectedJobDescription?.id) {
      toast.error('Please select a job role first');
      return;
    }

    const jobId = selectedJobDescription.id;
    const jobPosition = selectedJob;

    navigate(route, {
      state: {
        selectedJobId: jobId,
        autoSelectJob: true,
        jobRoleData: selectedJobDescription,
        jobPosition: jobPosition,
      },
    });
  };

  useEffect(() => {
    const fetchAllJobRoles = async () => {
      if (allJobs.length <= 0) {
        dispatch(getJobPositionsThunk());
      }
      if (jobRolesForDropDown === null) {
        dispatch(getJobPositionsforDropdown());
      }
    };

    fetchAllJobRoles();
  }, []);

  // activeSubTab is persisted in localStorage, so a user who last sat on
  // Outreached would land back there with the tab hidden once sourcing is
  // turned off. Send them back to All. Wait for the config to resolve first —
  // sourcingEnabled is false while it is still loading.
  useEffect(() => {
    if (
      !sourcingConfigLoading &&
      !sourcingEnabled &&
      currentActiveSubTab === 'OUTREACHED'
    ) {
      handleToggleSubTab('ALL');
    }
  }, [sourcingConfigLoading, sourcingEnabled, currentActiveSubTab]);

  // const TAB_SUBTAB_MAP = {
  //   SOURCED: ["MY_UPLOADS", "SOURCED_CANDIDATES"],
  //   INTERVIEW: ["SCHEDULED", "PROGRESS", "COMPLETED"],
  //   DECISION: ["ACCEPTED", "REJECTED"],
  // };

  const sourceDropdownOptions = useMemo(() => {
    if (currentActiveSubTab === 'MY_UPLOADS') {
      return [
        { value: 'SHORTLISTED', label: 'Shortlisted' },
        { value: 'RETROFIT', label: 'Retrofit' },
        { value: 'INVALID', label: 'Invalid' },
      ];
    }

    if (currentActiveSubTab === 'SOURCED_CANDIDATES') {
      return [
        { value: 'SHORTLISTED', label: 'Shortlisted' },
        { value: 'RETROFIT', label: 'Retrofit' },
      ];
    }

    return [];
  }, [currentActiveSubTab]);

  const activeSubSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubSubTab,
  );

  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );

  const subSubTabs =
    currentActiveSubTab === 'ALL'
      ? ['All', 'Shortlisted', 'Retrofit', 'Invalid']
      : currentActiveSubTab === 'MY_UPLOADS'
        ? ['Shortlisted', 'Retrofit', 'Invalid']
        : currentActiveSubTab === 'SOURCED_CANDIDATES'
          ? ['Shortlisted', 'Retrofit']
          : currentActiveSubTab === 'OUTREACHED'
            ? ['All'] // stage select is hidden on this tab
            : ['Shortlisted', 'Retrofit', 'Invalid'];

  const helpVideoIndex = currentActiveTab === 'INTERVIEW' ? 4 : 3;

  return (
    <>
    <div className="relative flex flex-col w-full">
      <style>{`
          .tab-active {
          z-index: 10;
      }

          .tab-active::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: -12px;
          width: 12px;
          height: 12px;
          background: radial-gradient(circle at -0% -0%,  #FAFAFA 64%,  #d1d5db 73%, #d1d5db 20%, white 72% );
      } 

      .tab-active::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: -12px;
        width: 12px;
        height: 12px;
        background:  radial-gradient(circle at 100% -0%,  #FAFAFA 64%,  #d1d5db 70%, #d1d5db 20%, white 72% );;
      }

       .dark .tab-active::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: -12px;
  width: 12px;
  height: 12px;
  background: radial-gradient(
    circle at -0% -0%,
    transparent 64%,
    #374151 70%,
    #374151 72%,
    #1e1b4b  75%
  );
}

.dark .tab-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: -12px;
  width: 12px;
  height: 12px;
  background: radial-gradient(
    circle at 100% -0%,
    transparent 64%,
    #374151  70%,
    #374151  72%,
    #1e1b4b 75%
  );
}
  `}</style>
      <div className="flex flex-row items-center justify-between mt-6 mb-3">
        <div className="flex flex-row items-center space-x-3">
          {showBackBtn && (
            <ArrowLeft
              className="text-textSecondary dark:text-gray-600 cursor-pointer size-5"
              onClick={() => navigate(-1)}
            />
          )}
          <div className="relative inline-block" ref={dropdownRef}>
            {/* Trigger - now an input */}
            <div
              className="flex items-center border border-1 border-gray-400 cursor-pointer min-w-0 bg-bgPrimary px-4 py-2 rounded-3xl dark:border  dark:border-gray-500 "
              onClick={() => {
                setShowDropDown(true);
              }}
            >
              <input
                type="text"
                value={showDropDown ? searchTerm : selectedJobRole || ''}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setShowDropDown(true);
                }}
                onFocus={() => {
                  setSearchTerm('');
                  setShowDropDown(true);
                }}
                placeholder={searchTerm || 'All Jobs'}
                title={selectedJobRole || 'All Job Roles'}
                className="text-textSecondary   text-base max-w-[180px] truncate bg-transparent outline-none border-none ring-0 focus:outline-none focus:ring-0 cursor-pointer min-w-0 mx-2 placeholder-textSecondary font-medium"
              />
              {selectedJobRole && false && selectedJobRole !== '' && (
                <X
                  className="size-4 flex-shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(updateCurrentJobRole(''));
                    dispatch(removeActiveFilter('JOB_ROLE'));
                    setSearchTerm('');
                    dispatch(triggerApply());
                    setShowDropDown(false);
                  }}
                />
              )}
              <ChevronDown className="size-4 ml-2 flex-shrink-0" />
            </div>

            {/* Dropdown */}
            {showDropDown && (
              <div className="absolute top-full left-0 mt-2 w-64 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50">
                <div className="max-h-52 overflow-y-auto">
                  {!searchTerm && (
                    <div
                      className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 text-sm"
                      onClick={() => {
                        dispatch(updateCurrentJobRole(''));
                        dispatch(removeActiveFilter('JOB_ROLE'));
                        setSearchTerm('');
                        dispatch(triggerApply());
                        setShowDropDown(false);
                      }}
                    >
                      All Jobs
                    </div>
                  )}
                  {jobRolesForDropDown
                    ?.filter((role) =>
                      role.role
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase()),
                    )
                    .map((role) => (
                      <div
                        key={role.id}
                        className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 text-sm"
                        onClick={() => {
                          dispatch(getJobDescriptionThunk(role.id));
                          dispatch(updateCurrentJobRole(role.role || 'All'));
                          dispatch(triggerApply());
                          setShowDropDown(false);
                          setSearchTerm('');
                        }}
                      >
                        {role.role}
                      </div>
                    ))}

                  {jobRolesForDropDown?.filter((role) =>
                    role.role?.toLowerCase().includes(searchTerm.toLowerCase()),
                  ).length === 0 && (
                    <div className="px-4 py-3 text-sm text-gray-400 text-center">
                      No results found
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-row items-center justify-between space-x-2">
          <button
            className={`${theme === 'dark' ? 'button' : 'border-btn !text-textPrimary'} ${
              selectedJobRole === '' ? 'opacity-50 !cursor-not-allowed' : ''
            } px-6 py-2.5`}
            onClick={() => {
              if (selectedJobRole !== '') {
                handleOpen();
              }
            }}
            disabled={selectedJobRole === ''}
            title={
              selectedJobRole === ''
                ? 'Select a specific job role to view JD'
                : 'View Job Description'
            }
          >
            <span>View JD</span>
          </button>
          <button
            className="px-6 py-2.5 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm transition-colors disabled:bg-none dark:disabled:bg-gray-600 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-100 disabled:text-white/50"
            onClick={handleUploadResumeClick}
            disabled={selectedJobRole === ''}
          >
            <span className="text-sm">Screen a Resume</span>
          </button>
          <button
            onClick={() => setIsHelpVideoOpen(true)}
            className="w-6 h-6 rounded-full border flex items-center justify-center flex-shrink-0 dark:border-gray-400 border-gray-500 dark:text-gray-400 text-gray-500 text-xs font-semibold hover:opacity-80 transition-opacity"
            title="Help"
          >
            ?
          </button>
        </div>
      </div>
      <div className="flex pb-0 mt-4 items-center justify-between space-x-4   dark:border-[#5A4479A3] border-gray-300 mb-[-1px]">
        <div className="flex items-center ">
          {navigationTab === 'ALL' && (
            <div
              onClick={() => handleToggleTab('SOURCED')}
              className={`px-3 mx-0.5 cursor-pointer relative ${currentActiveTab === 'SOURCED' ? 'bg-white py-3 dark:bg-indigo-950 dark:border-gray-700 tab-active rounded-t-[11px] border-t-[1px] border-l-[1px] border-r-[1px]' : ''} `}
            >
              <span
                className={`block relative
          ${
            currentActiveTab === 'SOURCED'
              ? 'font-semibold bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent !bg-gray-400 '
              : 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent hover:scale-[103%]'
          }
          before:block before:font-semibold before:invisible before:h-0 before:overflow-hidden before:content-[attr(data-text)]
        `}
                data-text="Candidate Profiles"
              >
                Candidate Profiles
              </span>
              {/* {currentActiveTab === 'SOURCED' && (
                <div className="h-1 bg-gradient-to-r from-pink-500 to-blue-500 mt-[0.8rem] rounded-lg absolute top-6 bottom-0 left-0 right-0"></div>
              )} */}
            </div>
          )}

          {(navigationTab === 'ALL' || navigationTab === 'INTERVIEW') && (
            <>
              <div
                onClick={() => handleToggleTab('INTERVIEW')}
                className={`px-3 mx-0.5 cursor-pointer relative ${currentActiveTab === 'INTERVIEW' ? 'bg-white  py-3 dark:bg-indigo-950 dark:border-gray-700 tab-active rounded-t-[11px] border-t-[1px] border-l-[1px] border-r-[1px]' : ''} `}
              >
                <span
                  className={`block relative
            ${
              currentActiveTab === 'INTERVIEW'
                ? 'font-semibold bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent'
                : 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent hover:scale-[103%]'
            }
            before:block before:font-semibold before:invisible before:h-0 before:overflow-hidden before:content-[attr(data-text)] 
          `}
                  data-text="Interviews"
                >
                  Interviews
                </span>
                {/* {currentActiveTab === 'INTERVIEW' && (
                  <div className="h-1 bg-gradient-to-r from-pink-500 to-blue-500 mt-[0.8rem] rounded-lg absolute top-6 bottom-0 left-0 right-0"></div>
                )} */}
              </div>

              <div
                onClick={() => handleToggleTab('DECISION')}
                className={`px-3 mx-0.5 cursor-pointer relative ${currentActiveTab === 'DECISION' ? 'bg-white py-3 dark:bg-indigo-950 dark:border-gray-700 tab-active rounded-t-[11px] border-t-[1px] border-l-[1px] border-r-[1px] -rounded-b-[11px]' : ''}`}
              >
                <span
                  className={`block relative
            ${
              currentActiveTab === 'DECISION'
                ? 'font-semibold bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent'
                : 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent hover:scale-[103%]'
            }
            before:block before:font-semibold before:invisible before:h-0 before:overflow-hidden before:content-[attr(data-text)]
          `}
                  data-text="Decision Center"
                >
                  Decision Center
                </span>
                {/* {currentActiveTab === 'DECISION' && (
                  <div className="h-1 bg-gradient-to-r from-pink-500 to-blue-500 mt-[0.8rem] rounded-lg absolute top-6 bottom-0 left-0 right-0"></div>
                )} */}
              </div>
            </>
          )}
        </div>

        {/* <div className="flex  items-center  justify-center pb-0">
          <div className="w-fit flex flex-row h-[35px] py-2  px-1 pl-0.5 border items-center border-gray-300 dark:!border-gray-700 rounded-full">
            <DropDownWithSearch
              className="rounded-3xl !border-none !outline-none"
              dropdownData={dropdownData}
              specialClasses="!border-none !outline-none bg-bgSecondary dark:bg-transparent !h-[30px]"
              onSelect={handleSelectJob}
              handleCrossClick={() => {
                setSelectedJob(null);
                dispatch(updateCurrentJobRole(''));
                dispatch(removeActiveFilter("JOB_ROLE"));
              }}
              placeholder={selectedJob ? selectedJob : 'Select Job Role'}
              selectedValue={selectedJob}
            />
            <button
              className={`${theme === 'dark' ? 'button disabled:!bg-none disabled:cursor-not-allowed' : 'border-btn'} !p-0 !m-0 !px-[12px] !py-[6px] !min-w-[55px] !h-[25px] flex items-center`}
              disabled={dropdownData.length === 0 || selectedJob === null}
              onClick={handleOpen}
            >
              <span className="text-xs text-textSecondary">View Jd</span>
            </button>
          </div>
        </div> */}
      </div>

      <div className=" relative flex space-x-4 !bg-bgPrimary dark:!bg-indigo-950  items-center px-10   dark:border-gray-700 w-[calc(100%+4rem)] !overflow-x-hidden -ml-8 -mr-8 py-4 border ">
        <div className="w-full flex items-center space-x-4  ">
          {/* <h3 className="text-textPrimary dark:text-gray-200 text-sm">
            Current Source :{' '}
          </h3> */}
          <button
            className={`${currentActiveSubTab === 'ALL' ? 'button !text-xs text-textSecondary dark:!text-white' : 'py-2 rounded-full border border-gray-300'} !px-5 !py-2 text-xs `}
            onClick={() => handleToggleSubTab('ALL')}
          >
            <span
              className={`${currentActiveSubTab !== 'ALL' ? 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white '} text-xs py-2`}
            >
              All
            </span>
          </button>
          {currentActiveTab === 'SOURCED' && (
            <>
              <button
                className={`${currentActiveSubTab === 'SOURCED_CANDIDATES' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'}  !px-2 !py-2 text-xs`}
                onClick={() => handleToggleSubTab('SOURCED_CANDIDATES')}
              >
                <span
                  className={`${currentActiveSubTab !== 'SOURCED_CANDIDATES' ? 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs `}
                >
                  Applications Received
                </span>
              </button>
              <button
                className={`${currentActiveSubTab === 'MY_UPLOADS' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2 text-xs `}
                onClick={() => handleToggleSubTab('MY_UPLOADS')}
              >
                <span
                  className={`${currentActiveSubTab !== 'MY_UPLOADS' ? 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white '} text-xs  `}
                >
                  My Uploads
                </span>
              </button>
              {/* Outreached is part of sourcing — same gate as the Header/Sidebar menus.
                  Hidden until the config confirms sourcing_enabled is true. */}
              {sourcingEnabled && (
                <button
                  className={`${currentActiveSubTab === 'OUTREACHED' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2 text-xs `}
                  onClick={() => handleToggleSubTab('OUTREACHED')}
                >
                  <span
                    className={`${currentActiveSubTab !== 'OUTREACHED' ? 'hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white '} text-xs  `}
                  >
                    Outreached Candidates
                  </span>
                </button>
              )}
              {/* Outreached rows are already past their screening gates — there is no
                  Shortlisted/Retrofit/Invalid stage to pick between. */}
              {currentActiveSubTab !== 'OUTREACHED' && (
              <div className="flex flex-row items-center justify-start">
                <Minus className="text-gray-300 rotate-90 dark:text-gray-600" />
                <span className="text-sm">Status : </span>
                {currentActiveTab === 'SOURCED' && (
                  <div className="ml-1 relative inline-block">
                    <select
                      value={activeSubSubTab}
                      onChange={(e) =>
                        dispatch(updateActiveSubSubTab(e.target.value))
                      }
                      className="
                        h-8 w-28 pl-3 pr-8
                        text-xs font-medium
                        rounded-full
                        bg-white text-gray-700
                        border border-gray-300
                        shadow-sm
                        cursor-pointer
                        transition-all duration-150
                        appearance-none
                        focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500
                        hover:border-gray-400
                        dark:bg-gray-900 dark:text-gray-200
                        dark:border-gray-700 dark:hover:border-gray-600
                      "
                    >
                      {subSubTabs.map((tab) => (
                        <option
                          key={tab}
                          value={tab}
                          className="bg-white text-gray-700 dark:bg-gray-900 dark:text-gray-200"
                        >
                          {tab}
                        </option>
                      ))}
                    </select>

                    {/* Custom dropdown arrow */}
                    <span
                      className="
                        pointer-events-none
                        absolute right-3 top-1/2 -translate-y-1/2
                        text-gray-400 dark:text-gray-500
                      "
                    >
                      <ChevronDown className="w-4 h-4 text-textPrimary dark:text-gray-300" />
                    </span>
                  </div>
                )}
              </div>
              )}
            </>
          )}
          {currentActiveTab === 'INTERVIEW' && (
            <>
              <button
                className={`${currentActiveSubTab === 'SCHEDULED' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2  text-xs`}
                onClick={() => handleToggleSubTab('SCHEDULED')}
              >
                <span
                  className={`${currentActiveSubTab !== 'SCHEDULED' ? 'text-textSecondary  hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs`}
                >
                  Scheduled
                </span>
              </button>
              <button
                className={`${currentActiveSubTab === 'PROGRESS' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2   text-xs`}
                onClick={() => handleToggleSubTab('PROGRESS')}
              >
                <span
                  className={`${currentActiveSubTab !== 'PROGRESS' ? 'text-textSecondary  hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs`}
                >
                  In Progress
                </span>
              </button>
              <button
                className={`${currentActiveSubTab === 'COMPLETED' ? 'button text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2 text-xs`}
                onClick={() => handleToggleSubTab('COMPLETED')}
              >
                <span
                  className={`${currentActiveSubTab !== 'COMPLETED' ? 'text-textSecondary  hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs`}
                >
                  Completed
                </span>
              </button>
            </>
          )}
          {currentActiveTab === 'DECISION' && (
            <>
              <button
                className={`${currentActiveSubTab === 'ACCEPTED' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2  text-xs`}
                onClick={() => handleToggleSubTab('ACCEPTED')}
              >
                <span
                  className={`${currentActiveSubTab !== 'ACCEPTED' ? 'text-textSecondary  hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs`}
                >
                  Selected
                </span>
              </button>
              <button
                className={`${currentActiveSubTab === 'REJECTED' ? 'button !text-xs text-textSecondary dark:!text-white' : 'px-4 py-2 rounded-full border border-gray-300'} !px-2 !py-2  text-xs`}
                onClick={() => handleToggleSubTab('REJECTED')}
              >
                <span
                  className={`${currentActiveSubTab !== 'REJECTED' ? 'text-textSecondary  hover:bg-gradient-to-r hover:from-pink-500 hover:to-blue-500 hover:bg-clip-text hover:text-transparent' : 'text-white'} text-xs`}
                >
                  Rejected
                </span>
              </button>
            </>
          )}
        </div>

        <FilterComponent />
      </div>
      {showFilterDropdown && <FilterDropDown />}
      <ColumnDropDown />
    </div>

    <HelpVideoModal
      open={isHelpVideoOpen}
      onClose={() => setIsHelpVideoOpen(false)}
      videos={HELP_VIDEOS}
      defaultIndex={helpVideoIndex}
    />
    </>
  );
}

export default CandidateManagementHeader;
